module.exports = __webpack_public_path__ + "img/shopCoupon.65dcf7e7.png";